var self = {};

self.initialise = function () {
  const $body = document.querySelector('body');

  if (navigator.userAgent.match(/Trident.*rv:11\./)) {
    $body.classList.add('IE11');
  }
}

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-ie11.js